import React from 'react';
import { useTranslation } from '@hooks/useTranslation';

const ErrorDisplay = ({ error, fieldErrors = {}, className = '' }) => {
    const { t } = useTranslation();

    // Don't render if no errors
    if (!error && Object.keys(fieldErrors).length === 0) {
        return null;
    }

    return (
        <div className={`form-error ${className}`}>
            {error && (
                <div className="general-error">
                    {error}
                </div>
            )}

            {Object.keys(fieldErrors).length > 0 && (
                <div className="field-errors">
                    {error && <hr className="error-separator" />}
                    <ul className="field-error-list">
                        {Object.entries(fieldErrors).map(([field, message]) => (
                            <li key={field} className="field-error-item">
                                <strong>{field}:</strong> {message}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default ErrorDisplay;
